module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payment_method":{"label":"Payment method","placeholder":"Enter payment method"}},"id":{"payment_method":{"label":"Payment method","placeholder":"Enter payment method"}}}')
  delete Component.options._Ctor
}
